import { CardPaymentProviderName } from '@nemuru-eng/js-api-client';

import { SinglePaymentProviderIds } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/constants/SinglePaymentMethodsProviderIds';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { SelectOption } from '@/types/selectOption';

export const CardPaymentProviderOptions = (t: GetTextIdTranslationType): SelectOption[] =>
  Object.values(CardPaymentProviderName)
    .map((providerName) => {
      const value = SinglePaymentProviderIds[providerName];
      return {
        value: value,
        display: t(providerName.toLowerCase()) || providerName.toLowerCase(),
      };
    })
    .filter((e) => e.value !== undefined);
